<div class="EFProductCard card {{ vertical ? 'EFProductCard--Vertical mb-3': '' }} {{ fill ? 'EFProductCard--Fill': '' }} {{ disabled ? 'EFProductCard--Disabled': '' }}"
    [attr.role]="disabled ? null : 'button'"
    [attr.tabindex]="disabled ? null : 0"
    [attr.aria-disabled]="disabled || null"
    [attr.aria-label]="getCardAriaLabel()"
    (click)="onCardClick()"
    (keydown)="onCardKeydown($event)">
    @if (productData && productData.error) {
        <div class="card-body text-center">
            <div class="alert alert-danger" role="alert">
                <div class="mb-3">
                    <i class="fa-regular fa-exclamation-triangle fa-3x" aria-hidden="true"></i>
                </div>
                <div>
                    {{ 'experience-finder.general.product-error' | locTranslate }}
                </div>
            </div>
        </div>
    }
    @if (productData && !productData.error) {
        <div class="EFProductCard-Image">
            <div class="card-img-top">
                <div class="EFProductCard-Image-Background bg-light text-white d-flex justify-content-center align-items-center" aria-hidden="true">
                    <i class="fa-regular fa-image fa-6x"></i>
                </div>
                <div>
                    @if (getCoverImage(); as image) {
                        <app-pg-image-autosize [src]="image" fit="cover" [alt]="'experience-finder.a11y.product-image' | locTranslate:'title':(productData.getTranslatedProductField('title') | stripHTML)"></app-pg-image-autosize>
                    }
                </div>
            </div>

            @if(productData.tagImages.length > 0) {
                <div class="EFProductCard-Image-TagImages" aria-hidden="true">
                    @for(tagImage of productData.tagImages; track tagImage) {
                        <app-pg-tag-image [tag]="tagImage.tag" [image]="tagImage.image" [color]="getTypeColor(productData.type)"></app-pg-tag-image>
                    }
                </div>
            }
            @if (productData.isPastProduct()) {
                <div class="EFProductCard-Image-PastProduct badge text-white bg-secondary">
                    <i class="fa-regular fa-hourglass-end" aria-hidden="true"></i>
                    <span class="ms-2">{{ 'experience-finder.general.past-' + productData.type | locTranslate }}</span>
                </div>
            }
        </div>
        <div class="EFProductCard-Content">
            <div class="card-body">
                <div class="EFProductCard-Content-Inner mb-2">
                    <h3 class="card-title h5 pb-2 mb-2">
                        @if (!productData.published) {
                            <div class="float-end">
                                <i class="fa-regular fa-eye-slash" aria-hidden="true"></i>
                            </div>
                        }
                        <span [innerHTML]="productData.getTranslatedProductField('title')"></span>
                    </h3>
                </div>
                @if (productData.link; as link) {
                    <div class="EFProductCard-Info EFProductCard-Info--Link">
                        <button type="button" class="btn btn-{{ link.color || 'primary' }}" (click)="onLinkButtonClick($event)">
                            @if (link.icon) {
                                <i class="{{link.icon}}" aria-hidden="true"></i>
                            }<span>{{link.text}}</span>
                        </button>
                    </div>
                }
                <div class="EFProductCard-Info EFProductCard-Info--Header">
                    @if (productData.getDateDisplay(); as date) {
                        <div>
                            <span>
                                <i class="fa-regular fa-calendar" aria-hidden="true"></i>
                                <small class="ms-1">{{date}}</small>
                            </span>
                        </div>
                    }
                    @if (getProductDuration() || productData.travel_stops) {
                        <div>
                            @if (getProductDuration(); as text) {
                                <span>
                                    <i class="fa-regular fa-stopwatch" aria-hidden="true"></i>
                                    <small class="ms-1">{{text}}</small>
                                </span>
                            }
                            @if (productData.travel_stops; as stops) {
                                <span>
                                    <i class="fa-regular fa-route" aria-hidden="true"></i>
                                    <small class="ms-1">{{stops}}</small>
                                </span>
                            }
                        </div>
                    }
                    @if (productData.stars; as stars) {
                        <div>
                            <span [attr.aria-label]="'experience-finder.app.product-stars' | locTranslate">
                                <small aria-hidden="true">
                                    @for (i of [1,2,3,4,5]; track i) {
                                        @if (i <= stars) {
                                            <i class="fa-solid fa-star text-warning opacity-100"></i>
                                        }
                                        @if (i > stars) {
                                            <i class="fa-regular fa-star text-muted opacity-50"></i>
                                        }
                                    }
                                </small>
                                <span class="visually-hidden">{{stars}}/5</span>
                            </span>
                        </div>
                    }
                    @if (productData.mean_of_transport; as transport) {
                        <div>
                            <small class="EFProductCard-Info-MeanOfTransport" aria-hidden="true">
                                @for (item of transport; track item) {
                                    @if (item == 'walking') {
                                        <i class="fa-regular fa-lg fa-walking"></i>
                                    }
                                    @if (item == 'bicycling') {
                                        <i class="fa-regular fa-lg fa-biking"></i>
                                    }
                                    @if (item == 'driving') {
                                        <i class="fa-regular fa-lg fa-car"></i>
                                    }
                                    @if (item == 'motorcycle') {
                                        <i class="fa-regular fa-motorcycle"></i>
                                    }
                                    @if (item == 'public_transport') {
                                        <i class="fa-regular fa-bus"></i>
                                    }
                                }
                            </small>
                        </div>
                    }

                    @if (productData.purchased || getCostDisplay()) {
                        <div>
                            @if (productData.purchased) {
                                <span class="badge bg-success me-2">{{ 'experience-finder.general.purchased' | locTranslate }}</span>
                            }

                            @if (getCostDisplay(); as cost) {
                                <small [innerHTML]="cost"></small>
                            }
                        </div>
                    }
                </div>
                <div class="EFProductCard-Info EFProductCard-Info--Footer">
                    <span>
                        @if (productData.type != 'custom') {
                            <span class="badge text-white" [style.backgroundColor]="getTypeColor(productData.type)">
                                <i class="fa-regular" [innerHTML]="getTypeIcon(productData.type)" aria-hidden="true"></i>
                                <span class="ms-2">{{productData.getTypeText()}}</span>
                            </span>
                        }
                    </span>
                    @if (productData.getCategoryText(); as text) {
                        <span class="badge bg-white border ms-2" [style.color]="getTypeColor(productData.type)" [style.borderColor]="getTypeColor(productData.type) + ' !important'">
                            <span [innerHTML]="text"></span>
                        </span>
                    }
                </div>
            </div>
        </div>
    }
</div>
